export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'f12ae95d-7876-47c1-9be8-1b31b2eea3d6';
export const MODAL_CLOSE_SEC = 2.5;
